import { IonChip, IonLabel } from '@ionic/react';
import { FC, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { HelperBeeModal } from './HelperBeeModal';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { EnvConfiguration } from '../config/EnvConfiguration';
import { AppPrincipal } from '../auth/AppPrincipal';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';

const useStyles = createUseStyles({
    chip: {
        height: 40,
        borderRadius: 24,
        paddingLeft: 6,
        textAlign: 'center',
        '--background': 'rgba(255, 255, 255, 0.7)',
        border: '1px solid var(--ion-color-step-350)',

        '& > img': {
            width: '16%'
        },

        '& ion-label': {
            flexGrow: 1,
            fontWeight: 500
        }
    }
});

export type IHelperBeeButtonProps = {
    label?: string;
    trackingFrom: 'Welcome' | 'Caregiver Tools';
};

export const HelperBeeButton: FC<IHelperBeeButtonProps> = ({ label = `I'm Bea. How can I help?`, trackingFrom }) => {
    const classes = useStyles();

    const config = useInstance(EnvConfiguration);
    const user = useInstance(AppPrincipal);
    const mixpanel = useInstance(MixPanelEventEmitter);

    const [open, setOpen] = useState(false);

    const onClickChip = () => {
        setOpen(true);
        mixpanel.track('AI Chatbot Opened', () => ({ from: trackingFrom }));
    };

    return (
        <>
            <div style={{maxWidth: 260}}>
                <IonChip onClick={onClickChip} className={classes.chip}>
                    <img alt="HelperBee" src="/assets/images/help/helper-bea.png" />
                    <IonLabel>{label}</IonLabel>
                </IonChip>
            </div>

            <HelperBeeModal
                isOpen={open}
                user={user}
                config={config}
                closeHandler={() => setOpen(false)}
            />
        </>
    );
};
